/* eslint-disable @reatom/unit-naming-rule */
import { Result } from '@blade/std-lib'
import {
  fetchCookingPairsRequestAction,
  pairRegistry,
} from '@root/entities/pair/atoms'

import { ExploreFilter } from '../../model'
import { ExploreFeedType } from '../../model/explore-feed-type'

import { reatomExploreTableBase } from './reatom-explore-table-base'

import type { PairModel } from '@root/entities/pair/atoms'
import type { TableData } from '@root/shared/ui-kit/data-table/atoms/reatom-data-table-state'

export const reatomExploreTableCooking = () => {
  return reatomExploreTableBase({
    feedType: ExploreFeedType.Cooking,
    loadPairs: async (
      ctx,
      {
        sorting,
        pagination: { limit, offset },
        params: { filters, network, period },
      },
    ) => {
      const result = await ctx.schedule(() =>
        fetchCookingPairsRequestAction(ctx, {
          filters: ExploreFilter.toPoolFiltersDto(filters, sorting, period),
          network,
          limit,
          offset,
        }),
      )

      return Result.map(result, (value) => {
        const data: TableData<PairModel> = {
          data: value.data.map((it) => pairRegistry.resolveFromDto(ctx, it)),
          hasNext: value.meta.hasNext,
        }

        return data
      })
    },
  })
}
